import PropTypes from 'prop-types';

import { useTheme } from '@zenbusiness/zui/styles';

import { SubscriptionResultStep } from './SubscriptionResultStep';
import { SUCCESS_ILLUSTRATION, ERROR_ILLUSTRATION } from '../constants';
import { CANCEL_FLOW_TYPES, getCancelClickstreamProps } from '../utils/cancelFlowConfig';

const cancelButtonRowSx = (theme) => ({
  '& > *': { width: '100%' },
  [theme.breakpoints.up('sm')]: {
    '& > *': { width: 'auto' },
    '& > :first-of-type': { order: 2 },
    '& > :last-child': { order: 1 }
  }
});

export function SubscriptionCancelResult({
  cancelFlowType,
  success,
  onReturnToSubscriptions,
  onReturnToDashboard,
  onContactUs,
  service
}) {
  const theme = useTheme();

  return (
    <SubscriptionResultStep
      success={success}
      successIllustrationSrc={SUCCESS_ILLUSTRATION}
      errorIllustrationSrc={ERROR_ILLUSTRATION}
      successHeadingMessageId="dashboard.subscriptionCancel.result.success.heading"
      successBodyMessageId="dashboard.subscriptionCancel.result.success.body"
      errorHeadingMessageId="dashboard.subscriptionCancel.result.error.heading"
      errorBodyMessageId="dashboard.subscriptionCancel.result.error.body"
      successButtons={[
        {
          labelMessageId: 'dashboard.subscriptionCancel.result.returnToSubscriptions',
          onClick: onReturnToSubscriptions,
          variant: 'contained',
          clickstreamProps: getCancelClickstreamProps(cancelFlowType, 'returnSubscriptions', service)
        },
        {
          labelMessageId: 'dashboard.subscriptionCancel.result.returnToDashboard',
          onClick: onReturnToDashboard,
          variant: 'outlined',
          clickstreamProps: getCancelClickstreamProps(cancelFlowType, 'returnDashboard', service)
        }
      ]}
      errorButtons={[
        {
          labelMessageId: 'dashboard.subscriptionCancel.result.contactUs',
          onClick: onContactUs,
          variant: 'contained',
          clickstreamProps: getCancelClickstreamProps(cancelFlowType, 'contactResult', service)
        },
        {
          labelMessageId: 'dashboard.subscriptionCancel.result.returnToSubscriptions',
          onClick: onReturnToSubscriptions,
          variant: 'outlined',
          clickstreamProps: getCancelClickstreamProps(cancelFlowType, 'returnSubscriptions', service)
        }
      ]}
      illustrationSize={220}
      illustrationSx={{ width: { xs: 160, sm: 220 } }}
      buttonRowSx={cancelButtonRowSx(theme)}
    />
  );
}

SubscriptionCancelResult.propTypes = {
  cancelFlowType: PropTypes.oneOf(Object.values(CANCEL_FLOW_TYPES)).isRequired,
  success: PropTypes.bool.isRequired,
  onReturnToSubscriptions: PropTypes.func.isRequired,
  onReturnToDashboard: PropTypes.func.isRequired,
  onContactUs: PropTypes.func.isRequired,
  service: PropTypes.string
};
